import React from "react";
import './ExplorePage.css';
import productpagebutton from '../../Images/close-arrow.svg';
import slandinguparrow from '../../Images/slanding-up-arrow.svg';
import productData from "../productData";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const ExplorePage = () => {
    const [selectedCategory, setSelectedCategory] = useState("Top Products");
    const navigate = useNavigate();
    const [selectedPdf, setSelectedPdf] = useState(null);
    
    const categories = ["Top Products", "Patient Monitoring Systems", "Emergency & Cardiac Care", "Hospital Furniture"];

    const filteredProducts = productData
    .filter((product) => {
        if (selectedCategory === "Top Products") return product.isTopProduct;
        return (
          (product.category && product.category.includes(selectedCategory)) || product.category === selectedCategory
        );
    })
    .slice(0, 3); 

    useEffect(() => {
        document.body.style.overflow = selectedPdf ? 'hidden' : 'auto';
    }, [selectedPdf]);


    return (
        <>
        <section className="explore-background-banner" id='products'>
            <div className="stockport-text">
                <h1 className="bg-text bg-text-top">Stockport</h1>
                <h1 className="bg-text bg-text-bottom">Stockport</h1>
            </div>
            <div className="explore-container" id ='products'>
                <div className="explore-section-left">
                    <h2 className="explore-white-text">Explore Our<br/><span className="highlight-text">Wide Range of Products</span></h2>
                </div>
                <div className="explore-section-right">
                    <p className="intro-text">Discover our extensive selection of products tailored to meet diverse needs. From high-performance tools to reliable everyday essentials, we’ve got you covered.</p>
                </div>
            </div>
        
            <div className="category-product-container">
                <div className="category-buttons-container">
                    {categories.map((category, index)=> (
                        <button key = {index} className={`category-buttons ${selectedCategory === category ? "active" : ""}`} onClick={()=>setSelectedCategory(category)}>
                            {category}
                        </button>
                    ))}
                </div>
            
                <div className="view-product-container" onClick={() => navigate('/products')}>
                    <p className="view-product-text"> View All Products <img src={productpagebutton} alt="Arrow Icon" className="product-page-button" /></p>
                </div>
            </div>

            <div className="products-container">
                {filteredProducts.map((product, index)=> (
                    <div key={product.id} className="product-card">
                    <div className="product-image-wrapper">
                    <img src={product.image} alt={product.name} className="product-image" />
                    <div className="product-info-card">
                        <div className="product-info-card-container">
                        <div className="product-card-details">
                            <h4 className="product-name-text">{product.name}</h4>
                            <p className="description-text">
                                {product.description.length > 50 ? `${product.description.slice(0, 35)}... ` : product.description}
                                {product.description.length > 50 && (
                                    <span className="read-more-link" onClick={() => setSelectedPdf(product.pdf)}>
                                        more
                                    </span>
                                )}
                            </p>
                        </div>
                        <div className="arrow-container">
                            <div className="arrow-display">
                                <span className="slanding-up-arrow" onClick={() => setSelectedPdf(product.pdf)} role="button">
                                    <img src={slandinguparrow} alt="slanding-up-arrow" className="slanding-up-arrow-img"/>
                                </span>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            ))}
            </div>
        </section>

        {selectedPdf && (
          <div className="pdf-overlay">
            <div className="pdf-frame-container">
              
              <div className="pdf-toolbar">
                <button onClick={() => setSelectedPdf(null)} className="pdf-close-button" aria-label="Close PDF">
                  <i className="bi bi-x-lg" />
                </button>
              </div>

              <iframe
                src={selectedPdf}
                className="pdf-iframe"
                title="Product PDF"
              />
            </div>
          </div>
        )}

        </>
    );
};

export default ExplorePage;
